import { render, staticRenderFns } from "./NewInbox.vue?vue&type=template&id=40156796"
import script from "./NewInbox.vue?vue&type=script&lang=js"
export * from "./NewInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports